// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const processExecutionsSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  processId: z.string().max(100),
  processVersion: z.string().max(200).optional(),
  status: z.string().max(50),
  progress: z.number().int().min(0).max(100),
  currentStepId: z.string().max(100).optional(),
  startedAt: z.string().max(200).datetime().optional(),
  completedAt: z.string().max(200).datetime().optional(),
  durationMs: z.number().int().min(0).max(2147483647).optional(),
  retryCount: z.number().int().min(0).max(100),
  maxRetries: z.number().int().min(0).max(100),
  inputs: z.record(z.string(), z.unknown()),
  outputs: z.record(z.string(), z.unknown()).optional(),
  variables: z.record(z.string(), z.unknown()),
  context: z.record(z.string(), z.unknown()),
  stepHistory: z.array(z.unknown()),
  error: z.record(z.string(), z.unknown()).optional(),
  correlationId: z.string().max(100).optional(),
  externalId: z.string().max(100).optional(),
  parentExecutionId: z.string().max(100).optional(),
  depth: z.number().int().min(0).max(100).optional(),
  resumeAt: z.string().max(200).datetime().optional(),
  workerId: z.string().max(100).optional(),
  processName: z.string().max(200).optional(),
  archived: z.boolean(),
  tenantId: z.string().max(100).optional(),
})

export type ProcessExecutionsInput = z.infer<typeof processExecutionsSchema>
